import SpacingControls from '../../utils/SpacingControls';
import { getSpacingClasses } from '../../utils/getSpacingClasses';
import { useSpacingOptions, createResetSpacingFunction } from '../../utils/spacing-utils';
import { __ } from '@wordpress/i18n';
import {
  useBlockProps,
  InnerBlocks,
  InspectorControls,
} from '@wordpress/block-editor';
import { Fragment } from '@wordpress/element';

const ALLOWED_BLOCKS = [
  'ensoul/button',
  'ensoul/image',
  'ensoul/heading',
  'ensoul/paragraph',
  'ensoul/divider',
  'ensoul/list',
  'ensoul/video',
];
const TEMPLATE = [
  ['ensoul/heading', { placeholder: 'Add heading...' }],
  ['ensoul/paragraph', { placeholder: 'Add paragraph...' }],
];

export default function Edit({ attributes, setAttributes }) {
  const blockProps = useBlockProps({
    className: `column ${getSpacingClasses(attributes)}`,
  });

  const spacingOptions = useSpacingOptions();

  // Create reset spacing function
  const resetSpacing = createResetSpacingFunction(setAttributes);

  return (
    <Fragment>
      <InspectorControls>
        <SpacingControls
          attributes={attributes}
          setAttributes={setAttributes}
          spacingOptions={spacingOptions}
          resetSpacing={resetSpacing}
        />
      </InspectorControls>

      <div {...blockProps}>
        <InnerBlocks
          allowedBlocks={ALLOWED_BLOCKS}
          template={TEMPLATE}
          templateLock={false}
        />
      </div>
    </Fragment>
  );
}
